import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import moment from 'moment'
import { displayOddsType, getDisplayCurrency, getStatus } from 'utils/converters'
import { bookmakers } from 'config'
import { connect } from 'react-redux'
import { editUserbet, deleteUserbet } from 'actions/userbets'

class ChangeBetModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      wager: 0,
      currency: 0,
      odds: 0,
      status: 0
    }
    this.onChangeOdds = this.onChangeOdds.bind(this)
    this.onChangeWager = this.onChangeWager.bind(this)
    this.onChangeCurrency = this.onChangeCurrency.bind(this)
    this.onChangeStatus = this.onChangeStatus.bind(this)
    this.submit = this.submit.bind(this)
    this.deleteBet = this.deleteBet.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (!!nextProps.bet) {
      this.setState({
        wager: nextProps.bet.wager,
        currency: nextProps.bet.currency,
        odds: nextProps.bet.odds,
        status: nextProps.bet.status
      })
    }
  }

  onChangeOdds(e) {
    this.setState({
      odds: +e.target.value
    })
  }

  onChangeWager(e) {
    this.setState({
      wager: +e.target.value
    })
  }

  onChangeCurrency(e) {
    this.setState({
      currency: e.target.value
    })
  }

  onChangeStatus(e) {
    this.setState({
      status: +e.target.value
    })
  }

  deleteBet(e) {
    e.preventDefault()
    const { dispatch } = this.props
    dispatch(deleteUserbet(this.props.bet.id))
    this.props.closeModal()
  }

  submit(e) {
    e.preventDefault()
    let changes = {}
    Object.keys(this.state).forEach(key => {
      if (this.state[key] !== this.props.bet[key])
        changes[key] = this.state[key]
    })
    if (Object.keys(changes).length > 0) {
      const { dispatch } = this.props
      dispatch(editUserbet(this.props.bet.id, changes))
    }
    this.props.closeModal()
  }

  render() {
    if (!this.props.bet)
      return <Modal show={false} />
    let bet = this.props.bet
    return (
      <Modal show={true} onHide={this.props.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{ bet.match.homeTeam + ' vs ' + bet.match.awayTeam}</Modal.Title>
        </Modal.Header>
        <form className='form-horizontal custom-bet-form'>
          <Modal.Body>
              <FormGroup label='Start time'>
                <input type='text' className='form-control' disabled
                  value={ moment(bet.match.startTime).format('MMM Do h:mm a') } />
              </FormGroup>
              <FormGroup label='Placed at'>
                <input type='text' className='form-control' disabled
                  value={moment(bet.createdAt).format('MMM Do h:mm a')} />
              </FormGroup>
              <FormGroup label='Odds type'>
                <input type='text' className='form-control' disabled
                  value={ displayOddsType(
                    bet.oddsType,
                    bet.output,
                    bet.oddsTypeCondition)}
                />
              </FormGroup>
              <FormGroup label='Bookmaker'>
                <input type='text' className='form-control' disabled
                  value={ bookmakers[bet.bookmaker._id] }
                />
              </FormGroup>
              <FormGroup label='Odds / current'>
                <div className='input-group'>
                  <input type='number' step='0.001' value={this.state.odds} className='form-control' onChange={this.onChangeOdds} />
                    <span className='input-group-addon'> / { bet.closingLine }</span>
                </div>
              </FormGroup>
              { bet.edge &&
                <FormGroup label='Edge when placed'>
                  <input type='text' className='form-control' disabled value={bet.edge + '%'} />
                </FormGroup>
              }
              <FormGroup label='Wager'>
                <input type='number' step='0.1' value={this.state.wager} className='form-control' onChange={this.onChangeWager}/>
              </FormGroup>
              <FormGroup label='Currency'>
                <select className='form-control' value={ this.state.currency } onChange={this.onChangeCurrency}>
                  { Object.keys(this.props.currencies).map(currency => {
                    return <option value={ currency } key={currency}>{ getDisplayCurrency[currency] }</option>
                  })}
                </select>
              </FormGroup>
              <FormGroup label='Status'>
                <select className={'form-control' + ' text-' + getStatus[this.state.status].className}
                  value={ this.state.status }
                  onChange={this.onChangeStatus }>
                  { Object.keys(getStatus).map(key => {
                    return (
                      <option key={key} value={+key}>{ getStatus[key].text }</option>
                    )
                  })}
                </select>
              </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <button type='button' className='btn btn-default' onClick={this.props.closeModal}>Close</button>
            <button type='button' className='btn btn-danger' onClick={this.deleteBet}>Delete bet</button>
            <button type='submit' className='btn btn-success pull-right' onClick={this.submit}>Save changes</button>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

class FormGroup extends Component {
  render() {
    return (
      <div className='form-group'>
        <label className='col-xs-3 control-label'>{ this.props.label }</label>
        <div className='col-xs-9'>
          { this.props.children }
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    currencies: state.currencies
  }
})(ChangeBetModal)



/** WEBPACK FOOTER **
 ** ./src/components/mybets/ChangeBetModal.js
 **/